<mat-form-field id="intInput" class="input-container mobile-field" [formGroup]="group" [appearance]="appearance">
  <mat-label>{{placeholder}}</mat-label>
  <input matInput #mobileInput
        [type]="inputType"
        [formControl]="control">
  <mat-icon class="icon" [ngClass]="icon" matSuffix *ngIf="!hideSuffixIcon"></mat-icon>
  <mat-error *ngIf="control && control.invalid && control.touched">{{validNoErr}}</mat-error>
  <mat-hint *ngIf="showHint">{{'Stories.donations.allpayment' | translatePipe | async}}</mat-hint>
</mat-form-field>
